import styled from 'styled-components';

const StyledLoading = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 24px;
    text-align: center;
    background: #f5f5f5;

    img {
        width: 100px;
    }

    .quote {
        padding-top: 16px;

        .text {
            max-width: 800px;
            font-size: 28px;
            font-weight: bold;
            line-height: 1.3;
            color: #1f1f1f;
        }

        .author {
            font-size: 14px;
            font-style: italic;
            color: #8c8c8c;

            &::before {
                padding-right: 8px;
                font-size: 20px;
                color: #8c8c8c;
                vertical-align: middle;
                content: '-';
            }

        }
    }

    .spinner {
        position: relative;
        display: inline-block;
        width: 80px;
        height: 80px;
        zoom: 45%;
        
        div {
            transform-origin: 40px 40px;
            animation: spinner 1.2s linear infinite;

            &::after {
                position: absolute;
                top: 3px;
                left: 37px;
                display: block;
                width: 6px;
                height: 18px;
                content: " ";
                background: #595959;
                border-radius: 20%;
            }

            &:nth-child(1) {
                transform: rotate(0deg);
                animation-delay: -1.1s;
            }

            &:nth-child(2) {
                transform: rotate(30deg);
                animation-delay: -1s;
            }

            &:nth-child(3) {
                transform: rotate(60deg);
                animation-delay: -0.9s;
            }

            &:nth-child(4) {
                transform: rotate(90deg);
                animation-delay: -0.8s;
            }

            &:nth-child(5) {
                transform: rotate(120deg);
                animation-delay: -0.7s;
            }

            &:nth-child(6) {
                transform: rotate(150deg);
                animation-delay: -0.6s;
            }

            &:nth-child(7) {
                transform: rotate(180deg);
                animation-delay: -0.5s;
            }

            &:nth-child(8) {
                transform: rotate(210deg);
                animation-delay: -0.4s;
            }

            &:nth-child(9) {
                transform: rotate(240deg);
                animation-delay: -0.3s;
            }

            &:nth-child(10) {
                transform: rotate(270deg);
                animation-delay: -0.2s;
            }

            &:nth-child(11) {
                transform: rotate(300deg);
                animation-delay: -0.1s;
            }

            &:nth-child(12) {
                transform: rotate(330deg);
                animation-delay: 0s;
            }
        }
    }

    @keyframes spinner {
        0% {
            opacity: 1;
        }

        100% {
            opacity: 0;
        }
    }

    .loading {
        padding-top: 16px;
    }

    p.message {
        padding-top: 4px;
        font-size: 24px;
        font-weight: 500;
    }

    p.button {
        font-size: 14px;
    }

    .anticon {
        font-size: 84px;
    }
`;
export default StyledLoading;
